import http from './http';

class AxiosCalls {
  static post(path, data) {
    return new Promise((resolve, reject) => {
      return http
        .post(`${path}`, data)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          if (err.response && err.response.status === 422) {
            const { error } = err.response;
            return reject(error);
          } else if (err.response && err.response.status === 400) {
            const { error } = err.response;
            return reject(error);
          } else if (err.response && err.response.status === 503) {
            return reject('Service Unavailable, please refresh and try again');
          } else if (err.response && err.response.status === 500) {
            return reject('Connection Error, check your internet connection');
          }
        });
    });
  }

  static get(path) {
    return new Promise((resolve, reject) => {
      return http
        .get(`${path}`)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          if (err.response && err.response.status === 404) {
            return reject('No Records');
          } else if (err.response && err.response.status === 500) {
            return reject('Connection Error, check your internet connection');
          }
        });
    });
  }
}

export default AxiosCalls;
